// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hostess-rank-base{width:100%;min-height:calc(100vh - 4rem)}.hostess-rank-base .custom-nav-block .van-bar .van-nav-bar__content .van-nav-bar__title{color:#fff;font-size:.45333rem;font-family:Outfit-Bold;font-weight:600}.hostess-rank-base .custom-nav-block .van-bar .van-nav-bar__content .van-nav-bar__right .tit-right{line-height:.42667rem!important}", ""]);
// Exports
module.exports = exports;
